import { compose } from 'redux';

import type { AppState } from '../AppState';
import type { VehicleState } from '../Vehicles/reducer';

const selectVehicleDomain = (state: AppState): VehicleState => state.vehicles;

export const selectVehiclesWebData = compose((domainState: VehicleState) => domainState.vehiclesWebData, selectVehicleDomain);
